import React, { Component } from 'react';
import { Modal, Button, Row, Table } from 'antd/lib';
import moment from 'moment';
import { withApollo } from 'react-apollo';

class ModalAuditoriaActuacion extends Component {
  render() {
    // console.log('PROPS');
    // console.log(this.props);

    const columns = [
      {
        title: 'Fecha',
        key: 'fecha',
        dataIndex: 'fecha',
        render: fecha => moment(fecha).format('DD/MM/YYYY HH:mm'),
      },
      {
        title: 'Usuario',
        key: 'usuario',
        dataIndex: 'usuario',
        render: usuario => usuario.apellido + ' ' + usuario.nombre,
      },
      {
        title: 'Descripcion',
        key: 'descripcion',
        dataIndex: 'descripcion',
      },
    ];

    return (
      <div>
        <Modal
          title={'Auditoria de Actuacion'}
          visible={this.props.mostrarModalAuditoriaActuacion}
          onCancel={this.props.ocultarModalAuditoriaActuacion}
          width={1200}
          footer={[
            <Button
              key="back"
              onClick={this.props.ocultarModalAuditoriaActuacion}
            >
              Volver
            </Button>,
          ]}
        >
          <Row>
            <Table
              // className="tablaAntecedentes"
              rowKey="fecha"
              columns={columns}
              size="small"
              pagination={false}
              dataSource={this.props.auditoria}
            />
          </Row>
        </Modal>
      </div>
    );
  }
}

export default withApollo(ModalAuditoriaActuacion);
